module.exports = __webpack_public_path__ + "img/15@2x.1906e1d6.png";